export const is_production = process.env.NODE_ENV === "production";
// export const is_production = true;

export const service_url = is_production
  ? "https://mystivio.com"
  : "https://mystivio.com";
